import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthContext } from '@/hooks/useAuthContext';
import { SuspensionBanner } from './SuspensionBanner';
import { TopNavbar } from './TopNavbar';
import { SidebarNav } from './SidebarNav';
import { MobileNavDrawer } from './MobileNavDrawer';

export const AppShell: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    user,
    orgName,
    orgRole,
    orgTier,
    orgStatus,
    isSuspended,
    hasPermission,
  } = useAuthContext();

  return (
    <div className="min-h-screen bg-[#09090B] text-[#FAFAFA] flex flex-col antialiased">
      <SuspensionBanner isSuspended={isSuspended} />
      <TopNavbar
        mobileMenuOpen={mobileMenuOpen}
        onToggleMobileMenu={() => setMobileMenuOpen(!mobileMenuOpen)}
        orgTier={orgTier}
        orgStatus={orgStatus}
        fullName={user?.fullName}
        orgRole={orgRole}
      />
      <div className="flex-1 flex overflow-hidden">
        <SidebarNav
          orgName={orgName}
          orgStatus={orgStatus}
          hasPermission={hasPermission}
        />
        <MobileNavDrawer
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
        />
        <main className="flex-1 overflow-y-auto bg-[#09090B] p-4 sm:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AppShell;
